var map = {
	"./feature_1.svg": "ZzFR",
	"./feature_2.svg": "k50M",
	"./feature_3.svg": "/0EX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9dsS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates ^\.\/feature_.*\.svg$
// module id = 9dsS
// module chunks = 0